import { call, put } from 'redux-saga/effects'
import get from 'lodash/get'
import { appActions } from '../../../redux'
import * as configMappers from './config.mapper'
import { LocalApiInterface } from '../../../api/requests/localApi'

export function* setEnvironmentSaga(api: LocalApiInterface): Generator {
  const config: any = yield call(api.appConfig)

  if (get(config, 'status') === 200 && get(config, 'statusText') === 'OK') {
    const configData = configMappers.getConfiguration(config.data)
    yield put(appActions.setEnvironmentSuccess(configData))
  }
}
